import * as React from 'react';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { CardsContainer } from '../../../__core/Components/Card/Style';
import Card from '../../../__core/Components/Card/Card';

type AttachmentProps = {
  downloadMaterial: () => void;
};

const Attachment: React.FunctionComponent<AttachmentProps> = ({
  downloadMaterial,
}) => {
  const { t } = useTranslation();

  return (
    <CardsContainer id="material-with-attachment">
      <Card
        icon={faDownload}
        onClick={downloadMaterial}
        title={t('Download')}
      />
    </CardsContainer>
  );
};

export default Attachment;
